import { CustomerBCCEnum, DunningCreateFormInput } from '@monetize/types/app';
import { Control, UseFormSetValue, useWatch } from 'react-hook-form';
import { MCustomMultiSelect } from '../../../../../components/Monetize/MCustomSelect/MCustomMultiSelect';
import {
  CUSTOMER_BCC_DISPLAY,
  CUSTOMER_BCC_OPTIONS,
} from '../../../../../constants/dunnings';

type CustomerBCC = {
  title: string;
  value: string;
};

interface CustomerBCCSelectorProps {
  index: number;
  control: Control<DunningCreateFormInput>;
  setValue: UseFormSetValue<DunningCreateFormInput>;
}

export const CustomerBCCSelector = ({
  control,
  setValue,
  index,
}: CustomerBCCSelectorProps) => {
  const { emailBillGroupBCCEmails, emailAccountBCCEmails } = useWatch({
    control,
    name: `dunningSteps.${index}`,
  });

  let selectedCustomerBCC: CustomerBCC[] = [];
  if (emailBillGroupBCCEmails) {
    selectedCustomerBCC = [
      ...selectedCustomerBCC,
      {
        value: CustomerBCCEnum.emailBillGroupBCCEmails,
        title: CUSTOMER_BCC_DISPLAY[CustomerBCCEnum.emailBillGroupBCCEmails],
      },
    ];
  }

  if (emailAccountBCCEmails) {
    selectedCustomerBCC = [
      ...selectedCustomerBCC,
      {
        value: CustomerBCCEnum.emailAccountBCCEmails,
        title: CUSTOMER_BCC_DISPLAY[CustomerBCCEnum.emailAccountBCCEmails],
      },
    ];
  }

  const onChange = (val: CustomerBCC[]) => {
    const selectedIds = val.map(({ value }) => value);

    Object.values(CustomerBCCEnum).map((value) =>
      setValue(
        `dunningSteps.${index}.${value}` as any,
        selectedIds.includes(value),
        {
          shouldDirty: true,
          shouldValidate: true,
        },
      ),
    );
  };

  return (
    <MCustomMultiSelect
      itemTitle="title"
      itemValue="value"
      items={CUSTOMER_BCC_OPTIONS}
      useExternalQuery
      multiple
      returnItem
      value={selectedCustomerBCC}
      closeButtonText="Apply"
      placeholder="Select Recipients"
      onChange={onChange}
      mt="0"
    />
  );
};
